import { render, staticRenderFns } from "./checkbox-iframe.vue?vue&type=template&id=a4da3fce"
import script from "./checkbox-iframe.vue?vue&type=script&lang=js"
export * from "./checkbox-iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports